import { SCORECARD_ELEMENT_SYMBOLS } from '../../../../Scorecard';
import { PresentationViewOptions } from '../types';

export const DEFAULT_PRESENTATION_VIEW_OPTIONS: PresentationViewOptions = {
  showClientAge: true,
  showClientName: true,
  showFinancialDetails: true,
  focusedElements: SCORECARD_ELEMENT_SYMBOLS,
  showInsights: true,
  showEmojis: true,
  showTargetScores: true,
};
